// src/lib/SettingsContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';

const SettingsContext = createContext(null);
export const useSettings = () => useContext(SettingsContext);

export const TRANSLATIONS = {
  en: {
    home:'Home', services:'Services', explore:'Explore', profile:'Profile',
    changeLocation:'Change',
    whatsOn:"What's on", thisWeekend:'This weekend', comingUp:'Coming up',
    allEvents:'All', today:'Today', weekend:'Weekend 🎉',
    sport:'Sport', music:'Music', kids:'Kids', community:'Community', markets:'Markets', arts:'Arts',
    about:'About this event', where:'Where', freeEntry:'Free entry',
    notInterested:'🤍 Interested', alreadyInterested:'❤️ Interested!',
    share:'Share', getTickets:'Get tickets', registerPlace:'Register free place',
    followOrganiser:'Follow organiser', unfollowOrganiser:'Following ✓',
    volunteersNeeded:'🙋 Volunteers needed',
    callOrganiser:'Call organiser', emailOrganiser:'Email organiser', bookingLink:'Booking link',
    addToCalendar:'Add to calendar', joinWaitlist:'Join waitlist',
    postEvent:'Post an event', publishEvent:'Publish event →',
    townServices:'Town Services', settings:'Settings',
    language:'Language', textSize:'Text size', highContrast:'High contrast',
    simpleLanguage:'Simple language', accessibility:'Accessibility',
    downloadData:'Download my data', deleteAccount:'Delete my account',
    loading:'Loading...', noEvents:'Nothing on yet',
    noEventsBody:'Check back soon — events are being added all the time.',
    promoted:'Promoted', featured:'Featured', scannerSource:'Auto-discovered',
    underEighteens:'Under-18s event — please register with parent/guardian details',
  },
  ga: {
    home:'Baile', services:'Seirbhísí', explore:'Iniúchadh', profile:'Próifíl',
    whatsOn:'Cad atá ar siúl', thisWeekend:'An deireadh seachtaine seo', comingUp:'Ag teacht',
    allEvents:'Gach rud', today:'Inniu', weekend:'Deireadh seachtaine 🎉',
    sport:'Spórt', music:'Ceol', kids:'Leanaí', community:'Pobal', markets:'Margaí', arts:'Ealaíona',
    about:'Faoin ócáid', where:'Cá háit', freeEntry:'Iontráil saor',
    notInterested:'🤍 Spéis agam', alreadyInterested:'❤️ Spéis agam!',
    share:'Comhroinn', getTickets:'Faigh ticéid', registerPlace:'Cláraigh',
    followOrganiser:'Lean an t-eagraí', unfollowOrganiser:'Ag leanúint ✓',
    volunteersNeeded:'🙋 Teastaíonn oibrithe deonacha',
    callOrganiser:'Glaoigh', emailOrganiser:'Ríomhphost', bookingLink:'Nasc áirithinte',
    addToCalendar:'Cuir le féilire', joinWaitlist:'Liosta feithimh',
    postEvent:'Cuir ócáid leis', publishEvent:'Foilsigh →',
    townServices:'Seirbhísí an Bhaile', settings:'Socruithe',
    language:'Teanga', textSize:'Méid téacs', highContrast:'Ardchontrárthacht',
    simpleLanguage:'Teanga shimplí', accessibility:'Inrochtaineacht',
    downloadData:'Íoslódáil mo chuid sonraí', deleteAccount:'Scrios mo chuntas',
    loading:'Ag lódáil...', noEvents:'Níl aon rud ar siúl fós',
    noEventsBody:'Seiceáil arís go luath.',
    promoted:'Curtha chun cinn', featured:'Ardaithe', scannerSource:'Aimsithe go huathoibríoch',
    underEighteens:'Ócáid do dhaoine faoi 18 — clárú le sonraí tuismitheora le do thoil',
  },
  pl: {
    home:'Strona główna', services:'Usługi', explore:'Odkryj', profile:'Profil',
    whatsOn:'Co się dzieje', thisWeekend:'Ten weekend', comingUp:'Nadchodzące',
    allEvents:'Wszystko', today:'Dziś', weekend:'Weekend 🎉',
    sport:'Sport', music:'Muzyka', kids:'Dzieci', community:'Społeczność', markets:'Targi', arts:'Sztuka',
    about:'O wydarzeniu', where:'Gdzie', freeEntry:'Wstęp wolny',
    notInterested:'🤍 Interesuje mnie', alreadyInterested:'❤️ Interesuje mnie!',
    share:'Udostępnij', getTickets:'Kup bilety', registerPlace:'Zarejestruj się',
    followOrganiser:'Obserwuj', unfollowOrganiser:'Obserwujesz ✓',
    volunteersNeeded:'🙋 Potrzebni wolontariusze',
    callOrganiser:'Zadzwoń', emailOrganiser:'Email', bookingLink:'Rezerwacja',
    addToCalendar:'Dodaj do kalendarza', joinWaitlist:'Lista oczekujących',
    postEvent:'Dodaj wydarzenie', publishEvent:'Opublikuj →',
    townServices:'Usługi w mieście', settings:'Ustawienia',
    language:'Język', textSize:'Rozmiar tekstu', highContrast:'Wysoki kontrast',
    simpleLanguage:'Prosty język', accessibility:'Dostępność',
    downloadData:'Pobierz moje dane', deleteAccount:'Usuń konto',
    loading:'Ładowanie...', noEvents:'Brak wydarzeń',
    noEventsBody:'Sprawdź ponownie wkrótce.',
    promoted:'Promowane', featured:'Wyróżnione', scannerSource:'Automatycznie odkryte',
    underEighteens:'Wydarzenie dla osób poniżej 18 lat — zarejestruj dane rodzica/opiekuna',
  },
  uk: {
    home:'Головна', services:'Послуги', explore:'Дослідити', profile:'Профіль',
    whatsOn:'Що відбувається', thisWeekend:'Цей вихідний', comingUp:'Незабаром',
    allEvents:'Усе', today:'Сьогодні', weekend:'Вихідні 🎉',
    sport:'Спорт', music:'Музика', kids:'Діти', community:'Спільнота', markets:'Ринки', arts:'Мистецтво',
    about:'Про подію', where:'Де', freeEntry:'Вільний вхід',
    notInterested:'🤍 Цікавить', alreadyInterested:'❤️ Цікавить!',
    share:'Поділитись', getTickets:'Квитки', registerPlace:'Зареєструватись',
    followOrganiser:'Стежити', unfollowOrganiser:'Стежу ✓',
    volunteersNeeded:'🙋 Потрібні волонтери',
    callOrganiser:'Зателефонувати', emailOrganiser:'Написати', bookingLink:'Бронювання',
    addToCalendar:'Додати до календаря', joinWaitlist:'Список очікування',
    postEvent:'Додати подію', publishEvent:'Опублікувати →',
    townServices:'Послуги міста', settings:'Налаштування',
    language:'Мова', textSize:'Розмір тексту', highContrast:'Високий контраст',
    simpleLanguage:'Простий режим', accessibility:'Доступність',
    downloadData:'Завантажити мої дані', deleteAccount:'Видалити обліковий запис',
    loading:'Завантаження...', noEvents:'Подій поки немає',
    noEventsBody:'Перевірте пізніше.',
    promoted:'Рекламовані', featured:'Рекомендовані', scannerSource:'Автоматично знайдено',
    underEighteens:'Захід для осіб до 18 років — вкажіть дані батька/опікуна',
  },
};

export const LANGUAGES = [
  { code: 'en', label: 'English',    flag: '🇮🇪' },
  { code: 'ga', label: 'Gaeilge',    flag: '🇮🇪' },
  { code: 'pl', label: 'Polski',     flag: '🇵🇱' },
  { code: 'uk', label: 'Українська', flag: '🇺🇦' },
];

export const SettingsProvider = ({ children }) => {
  const [language,       setLanguageState]       = useState(() => localStorage.getItem('g-lang')     || 'en');
  const [textSize,       setTextSizeState]       = useState(() => localStorage.getItem('g-textsize') || 'normal');
  const [highContrast,   setHighContrastState]   = useState(() => localStorage.getItem('g-hc')       === 'true');

  const setLanguage = (v)       => { setLanguageState(v);         localStorage.setItem('g-lang', v); };
  const setTextSize = (v)       => { setTextSizeState(v);         localStorage.setItem('g-textsize', v); };
  const setHighContrast = (v)   => { setHighContrastState(v);     localStorage.setItem('g-hc', v); };

  useEffect(() => {
    document.documentElement.lang = language;
    // Most of the app's text is sized with hardcoded px in inline styles,
    // not rem/em — so changing the root font-size alone barely affects
    // anything visible. `zoom` scales the whole rendered page regardless
    // of the units used underneath, which is what actually makes this
    // setting work app-wide.
    const zoomLevels = { normal: '100%', large: '115%', xlarge: '130%' };
    document.documentElement.style.zoom = zoomLevels[textSize] || '100%';
    if (highContrast) document.documentElement.setAttribute('data-high-contrast', 'true');
    else document.documentElement.removeAttribute('data-high-contrast');
  }, [language, textSize, highContrast]);

  const t = (key) => {
    const tr = TRANSLATIONS[language] || TRANSLATIONS.en;
    return tr[key] || TRANSLATIONS.en[key] || key;
  };

  return (
    <SettingsContext.Provider value={{
      language, setLanguage, textSize, setTextSize,
      highContrast, setHighContrast,
      t, LANGUAGES,
    }}>
      {children}
    </SettingsContext.Provider>
  );
};
